export default __webpack_public_path__ + "static/media/suitjamas.4acd8aff.png";